import { useConnection, useEnsName } from 'wagmi';
import { PURCHASE_TEST_CHAIN, IS_PURCHASE_TEST } from '../../__test_utils__/purchase-test';

export const useConnectedAccount = () => {
  const account = useConnection();
  const { address, chain, chainId, isConnected } = account;

  const ensName = useEnsName({ address: account.address });

  if (process.env.VITE_APP_MOCK_ENV === 'true') {
    return {
      connectedAddress: '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266',
      connectedAccountName: 'cypress.test',
      connectedChainId: Number(localStorage.getItem('mock-chain-id')) || 31337,
      connectedChainAlias: 'hardhat',
      connectorName: 'MetaMask',
      isConnected: true,
    };
  }

  if (IS_PURCHASE_TEST) {
    return {
      connectedAddress: '0x09dEa15D4E1F82787e181F23788Dc3f4b3d3DAE4',
      connectedAccountName: 'purchase.test',
      connectedChainId: PURCHASE_TEST_CHAIN.id,
      connectedChainAlias: PURCHASE_TEST_CHAIN.alias,
      connectorName: 'MetaMask',
      isConnected: true,
    };
  }

  return {
    connectedAddress: address,
    connectedAccountName: ensName.data,
    connectedChainId: chainId,
    connectedChainAlias: chain?.name || '',
    connectorName: account?.connector?.name || '',
    isConnected,
  };
};
